/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const nestedRouter = {
  path: '/customer',
  component: Layout,
  redirect: '/customer/company/manager',
  name: 'customer',
  meta: {
    title: 'customer',
    icon: 'peoples'
  },
  children: [
    {
      path: 'grade',
      name: 'grade',
      component: () => import('@/views/customer/grade/index'),
      meta: {
        title: 'grade',
        enName: 'GROUP_GRADE_SHOW'
      }
    },
    {
      path: 'company',
      component: () => import('@/views/customer/company/index'), // Parent router-view
      name: 'company',
      meta: { title: 'company' },
      redirect: '/customer/company/manager',
      children: [
        {
          path: 'manager',
          component: () => import('@/views/customer/company/manager'),
          name: 'manager',
          meta: { title: 'manager', enName: 'COMPANY_MGR_SHOW' }
        },
        {
          path: 'childMember',
          component: () => import('@/views/customer/retail/index'),
          name: 'childMember',
          meta: { title: 'childMember', enName: 'COMPANT_CHILD_MGR' }
        }
      ]
    },
    {
      path: 'retail',
      name: 'retail',
      component: () => import('@/views/customer/retail/index'),
      meta: { title: 'retail', enName: 'RETAIL_MGR' }
    }
  ]
}

export default nestedRouter
